import { useFormikContext } from 'formik';
import { type ContractByIDFormValues } from '@/modules/admin-dashboard/components/contractManagement/ContractByID/ContractDetailsTab.tsx';
import { Button } from 'ui';
import { DownloadGreyIcon, UploadWhiteIcon } from 'ui/icons';

interface ContractByIDHeaderActionProps {
  onDownload: () => void;
  onUploadFiles: () => void;
  hasFile: boolean;
  showUploadFiles: boolean;
  readOnly: boolean;
}

export const ContractByIDHeaderAction = ({
  onDownload,
  onUploadFiles,
  hasFile,
  showUploadFiles,
  readOnly,
}: ContractByIDHeaderActionProps) => {
  const formik = useFormikContext<ContractByIDFormValues>();

  const showSaveButton = formik.dirty && !readOnly;

  return (
    <div className="flex items-center gap-2">
      {showSaveButton && (
        <Button
          className="h-10 min-h-10 w-fit min-w-0 px-4 text-xs"
          onClick={formik.submitForm}
          disabled={formik.isSubmitting}
          loading={formik.isSubmitting}
        >
          Save
        </Button>
      )}
      {/* <DropdownMenu */}
      {/*   items={hasHistory ? versionHistoryItems : [{ label: 'No history', onClick: () => undefined }]} */}
      {/*   button={ */}
      {/*     <Button variant="secondary" className="w-fit gap-2" disabled={!hasHistory}> */}
      {/*       <img src={VersionHistoryIcon} alt="" className="h-5 w-5" /> */}
      {/*       Version history */}
      {/*     </Button> */}
      {/*   } */}
      {/*   className="w-[260px] divide-white" */}
      {/*   containerClassName="w-fit" */}
      {/* /> */}
      <Button variant="secondary" className="w-fit gap-2" onClick={onDownload} disabled={!hasFile}>
        <img src={DownloadGreyIcon} alt="" className="h-5 w-5" />
        Download
      </Button>
      {showUploadFiles && (
        <Button className="w-fit gap-2" onClick={onUploadFiles} disabled={readOnly}>
          <img src={UploadWhiteIcon} alt="" className="h-5 w-5" />
          Upload new files
        </Button>
      )}
      {/* <Button variant="secondary" className="w-fit gap-2" onClick={onEdit}> */}
      {/*   <img src={EditGrayIcon} alt="" className="h-5 w-5" /> */}
      {/*   Edit */}
      {/* </Button> */}
    </div>
  );
};
